export default __webpack_public_path__ + "static/media/WallpaperLogin.5a731b1b.svg";